import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function deleteWallet(
  accountId: string,
  walletId: string,
): Promise<void> {
  try {
    await axios.delete(`/accounts/${accountId}/wallets/${walletId}`);
  } catch (error) {
    throwSylaApiError(error);
  }
}
